import type { ArtistIntake, ConsentAcceptance, DarkRoomReview } from "./schemas";
import type { AiRouteDecision } from "./aiRouter";
import { createMockIntake } from "./darkRoom";
import { createPreparationRun } from "./assessmentRun";

/** Ephemeral preview uses the same consent, route, input and method boundary as generation. */
export function createPreparationPreview(intake: ArtistIntake, consent: ConsentAcceptance, route: AiRouteDecision): DarkRoomReview | null {
  try {
    return createPreparationRun(createMockIntake(intake, consent, "local"), intake.songText ?? "", route).review;
  } catch {
    return null;
  }
}
